export const DOMAIN_FORM_SECTIONS_CONFIG = "FORM_SECTIONS_CONFIG";
